import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { modules } from '../data/content';
export function Modules() {
  return <section className="bg-ice px-4 py-5 sm:px-6" data-id="element-104" data-mp="1r4sov7zfhav5">
      <div className="mx-auto max-w-2xl" data-id="element-105" data-mp="1vxc2g4y485zy">
        <h2 className="text-center font-heading text-xl font-extrabold uppercase text-deep sm:text-3xl" data-id="element-106" data-mp="1vydcq77b4ogm">
          What’s included
        </h2>
        <div className="mt-3 space-y-2.5" data-id="element-107" data-mp="145w6hkao56x2">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-xl border border-clinical/15 bg-white shadow-sm" data-id="element-108" data-mp="147z70y9g6ig1">
              <div className="flex items-center gap-2 bg-deep px-3 py-2" data-id="element-109" data-mp="1d5jc6iafkyvx">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-glow" strokeWidth={2.5} aria-hidden="true" data-id="element-110" data-mp="1i66ywrrmmtkc" />
                <h3 className="font-heading text-[0.78rem] font-extrabold uppercase leading-tight text-white sm:text-base" data-id="element-111" data-mp="2tkucdj3ije5j">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-3 py-2.5" data-id="element-112" data-mp="3tyc9004bu2fb">
                <p className="text-[0.86rem] leading-snug text-muted sm:text-base" data-id="element-113" data-mp="3tzna1s6e0w2q">
                  {mod.body}
                </p>
                <p className="mt-1 font-heading text-[0.72rem] font-bold uppercase tracking-wide text-turq sm:text-sm" data-id="element-114" data-mp="3k0oacz3loarv">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}